export enum Option {
	ValuesIndex = 'Option::values.index',
	ValuesCreate = 'Option::values.create',
	ValuesUpdate = 'Option::values.update',
	ValuesDelete = 'Option::values.delete',
}
